// extracted by mini-css-extract-plugin
export var checkbox = "_8n-0";
export var circle = "_8n-3";
export var horizontalContainer = "_8n-7";
export var sm = "_8n-5";
export var switch0 = "_8n-2";
export var switchDisabled = "_8n-8";
export var switchEnabled = "_8n-1";
export var textSwitchContainer = "_8n-9";
export var textSwitchOption = "_8n-a";
export var textSwitchOptionSelected = "_8n-b";
export var verticalContainer = "_8n-6";
export var xs = "_8n-4";